import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkCadastralFields } from '../../actions/rosreestrData/checkCadastralFields';
import { selectOfferCategory } from '../../selectors/offer';
import { CadastralNumbers } from './CadastralNumbers';
import { IAngularProps } from './types';
import { useCadastralFields } from './hooks';
import { useIsMobileDevice } from '../../hooks';
import { useCadastralNumbersDestinationModal } from './hooks/useCadastralNumbersDestinationModal';
import { useNoCadastralNumberReasonModal } from './hooks/useNoCadastralNumberReasonModal';
import { useInformModal } from './hooks/useInformModal';

export const CadastralNumbersContainer: React.FC<IAngularProps> = ({ addFormService, $rootScope }) => {
  const offerCategory = useSelector(selectOfferCategory);

  const [showNoCadastralNumberButton, setShowNoCadastralNumberButton] = React.useState(false);

  const { buildingCadastralNumber, cadastralNumber, onChange, requestError } = useCadastralFields({
    addFormService,
    $rootScope,
    setShowNoCadastralNumberButton,
  });

  const dispatch = useDispatch();

  const handleSubmit = React.useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.stopPropagation();
      event.preventDefault();

      dispatch(checkCadastralFields());
    },
    [dispatch],
  );

  const destinationModalState = useCadastralNumbersDestinationModal();

  const reasonModalState = useNoCadastralNumberReasonModal({
    setShowNoCadastralNumberButton,
  });

  const informModalState = useInformModal();

  const isMobile = useIsMobileDevice();

  return (
    <CadastralNumbers
      isLand={offerCategory === 'landSale'}
      buildingNumber={buildingCadastralNumber}
      landNumber={cadastralNumber}
      onChange={onChange}
      onSubmit={handleSubmit}
      requestError={requestError}
      showNoCadastralNumberButton={showNoCadastralNumberButton}
      isMobile={isMobile}
      destinationModalState={destinationModalState}
      reasonModalState={reasonModalState}
      informModalState={informModalState}
    />
  );
};
